/**
 * The Map page's background: CARTO's Voyager raster tiles, drawn under the
 * page's own markers.
 *
 * Since CARTO's Basemap Terms of 26 August 2026, a tile requested without a
 * key comes back stamped "API KEY REQUIRED". The key is not a secret — every
 * browser sends it in each tile address — so what protects it is the website
 * restriction set on CARTO's side, not hiding it here.
 *
 * Rules from those terms that are easy to break by accident:
 * - A wrong or blocked key does not error. CARTO answers 200 with the same
 *   watermarked tile, so check any key change by looking at the map.
 * - Keep the OpenStreetMap and CARTO credit visible (s13); missing credit
 *   can cost the key.
 * - Tiles go straight from the browser to CARTO: never proxy or cache them on
 *   our servers (s9.c). Do not add `Referrer-Policy: no-referrer` either — a
 *   key restricted to our website needs the browser to say where it is.
 * - CARTO says raster tiles are "being retired" (no date). Moving to its
 *   vector style is a MapLibre job, not a change of address here.
 */

// IDS CRM's free CARTO basemap key, added 14 Sep 2026. Once it is restricted
// to crm.ids-dairy.com, a local copy of the app can use its own key through
// REACT_APP_CARTO_BASEMAP_KEY (baked in at build time, like every REACT_APP_).
export const CARTO_BASEMAP_KEY =
  process.env.REACT_APP_CARTO_BASEMAP_KEY || 'cb1_3keu_1_bd955ec632695b53287875bd';

export const CARTO_SUBDOMAINS = 'abcd';

export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

/**
 * Leaflet tile template. `{r}` asks for @2x tiles on sharp screens, which
 * lose the watermark with a key just as the 1x tiles do (checked 14 Sep 2026).
 * @param {string} key
 * @returns {string}
 */
export function cartoVoyagerTileUrl(key = CARTO_BASEMAP_KEY) {
  return `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(key)}`;
}
